export function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

export function getPathValue(obj, path) {
  if (!isObject(obj)) return;

  const keys = path.split(".");
  let value = obj;
  while (keys.length) {
    const key = keys.shift();
    if (value[key] === undefined) {
      return undefined;
    }
    value = value[key];
  }
  return value;
}

export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (!Object.prototype.hasOwnProperty.call(source, key)) continue;

      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function noop() {
  // eslint-disable-next-lin @typescript-eslint/no-empty-function
}
